<template>
  <div class="col-sm">

    <div class="">
      <div class="select form-inline">
          <div class="form-check form-check-inline">
            <label class="px-md-4">快递</label>
            <select class="custom-select" @change="reSelectOrders" v-model="shipCompanySign">
              <option value="">全部</option>
              <option value="yuantong">圆通</option>
              <option value="zhongtong">中通</option>
              <option value="youzheng">邮政</option>
              <option value="shentong">申通</option>
              <option value="shunfeng">顺丰</option>
              <option value="shunfengguoji">顺丰国际</option>
            </select>
          </div>

           <div class="form-check form-check-inline">
            <label class="px-md-4">附件</label>
            <select class="custom-select" @change="reSelectOrders" v-model="extraItemsSign">
              <option value="">全部</option>
              <option v-for="item of extraItems" :value="item">{{item}}</option> 
            </select>
          </div>
      </div>

      <table class="table table-sm table-hover">
        <thead class="thead-default">
          <th v-on:click='toggleCheckAll' nowrap>
            <input class='main-input-toggle' title='选择所有' type='checkbox'>
          </th>
          <th nowrap>公司/订单号</th>
          <th>快递单号生成时间</th>
          <th>产品</th>
          <th>其他</th>
        </thead>
        <tbody>
          <tr v-for="order in orders" >
            <td>
              <input 
              class="sub-input-toggle" 
              type="checkbox"
              :data-id="order.order_no"
              :data-ship-company="order.ship_company"
              :data-has-extra="order.extra_items.length > 0 ? 'has_extra' : 'no_extra'"
              :checked="selectedIds.indexOf(String(order.order_no)) >= 0"
              @click="toggleCheckSortedByTable">
            </td>
            <td>
              {{getCompanyDisplay(order.company_code)}}<br/>
              <router-link :to="'/orders/' + order.order_no">{{order.order_no}}</router-link><br>
              {{order.company_order_no}}
            </td>
            <td>
              <div>{{formatTime(order.ship_no_at)}}</div>
            </td>
            <td>
              {{order.order_name}} X <span v-html="renderOrderItems(order)"></span><br/>
              {{order.product_name}}
            </td>
            <td>
              <order-extra-item :order="order" :show-address="true" :show-ship-company="true"></order-extra-item>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import InputMixin from '@/mixins/input'
import OrderMixin from '@/mixins/order'
import OrderExtraItem from '@/components/_small/OrderExtra'
import {formatTime} from '@/utils/time'

function reSelectOrders () {
  this.orders.forEach((order) => {
    var meet = true
    if (this.shipCompanySign !== '' && order.ship_company !== this.shipCompanySign) {
      meet = false
    }

    if (this.extraItemsSign !== '') {
      var hasExtra = false
      for (const item of order.extra_items) {
        if (item.name === this.extraItemsSign) {
          hasExtra = true
          break
        }
      }

      if (!hasExtra) {
        meet = false
      }
    }

    if (meet === false) {
      let index = this.selectedIds.indexOf(order.order_no)
      if (index >= 0) {
        this.selectedIds.splice(index, 1)
      }
    } else {
      if (this.selectedIds.indexOf(order.order_no) < 0) {
        this.selectedIds.push(String(order.order_no))
      }
    }
  })

  this.$emit('input-check', this.selectedIds)
}

function parseExtraItems() {
  var items = new Array() 

  for (const order of this.orders) {
    for (const item of order.extra_items) {
      if (items.indexOf(item.name) == -1) {
        items.push(item.name)
      }
    }
  }

  return items
}

export default {
  mixins: [OrderMixin, InputMixin],
  data () {
    return {
      extraItemsSign: '',
      shipCompanySign: '',
      hasExtra: ''
    }
  },
  props: ['orders', 'title', 'count'],
  components: {OrderExtraItem},
  methods: {
    reSelectOrders,
    parseExtraItems,
    formatTime
  },
  computed: {
    extraItems () {
      return this.parseExtraItems()
    }
  }
}
</script>